import { makeStyles } from '@material-ui/core/styles';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  root: {
    margin: '24px 0',
    flexGrow: 1,
  },
  buttonsContainer: {
    '& > a + button': {
      marginLeft: spacing.xsmall,
    },
  },
});

export default useStyles;
